var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('container-right',{class:{ 'ml-200px': _vm.ml }},[_vm._t("pageRight")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }